import { FilterQueryParams } from '@epicuro-next/models/products';
import {
  SearchSortType,
  SortingDirection,
} from 'graphql-api/gql-api-interfaces';

export const initialFilterQueryParams: FilterQueryParams = {
  q: '',
  f: '',
  subsites: '',
  availability: '',
  maxAge: '',
  rrp: '',
  wsp: '',
  sortField: SearchSortType.Default,
  sortDirection: SortingDirection.Desc,
};

export const initialFilterQueryParamsExceptQuery: Omit<FilterQueryParams, 'q'> =
  {
    f: '',
    subsites: '',
    availability: '',
    maxAge: '',
    rrp: '',
    wsp: '',
    sortField: SearchSortType.Default,
    sortDirection: SortingDirection.Desc,
  };
